// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var text = "IntroText-module--text--afR9E";
export var button = "IntroText-module--button--II2sl";
export var buttonText = "IntroText-module--buttonText--0GJZH";